export default {
    approvals: "Aprovações",
    delegates: "Delegados",
    employees: "Funcionários"
}